import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CountriesService} from './countries.service';
import {ListHttpParameters} from '../../shared/models/list-http-parameters';

@Injectable({
  providedIn: 'root'
})
export class KeyWordTranslatorService {

  constructor(
    private translateService: TranslateService,
    private countriesService: CountriesService,
  ) {
  }

  translateCountries(params: ListHttpParameters, paramName: string): ListHttpParameters {
    if (!params.keyword) {
      params[paramName] = null;
      return params;
    }

    const countriesList = this.countriesService.getCountiresList();
    const keywords = this.splitKeywords(params.keyword);
    const translatedCountries = [];

    keywords.forEach(keyword => {
      const entry = Object.entries(countriesList).find(country => country[1].toLowerCase() === keyword);
      if (entry) {
        translatedCountries.push(entry);
      }
    });

    translatedCountries.forEach(country => {
      keywords.splice(keywords.indexOf(country[1].toLowerCase()), 1);
    });
    if (translatedCountries.length > 0) {
      params.keyword = keywords.join(',');
      params[paramName] = Array.from(translatedCountries.map(country => country[0])).join(',');
    } else {
      params[paramName] = null;
    }

    return params;
  }

  translateEnumValues(params: ListHttpParameters, paramName: string, enumToTranslate: any): ListHttpParameters {
    if (!params.keyword) {
      params[paramName] = null;
      return params;
    }

    const enumValues = this.getEnumLabelsValues(enumToTranslate);
    const keywords = this.splitKeywords(params.keyword);
    const translatedEnums = [];

    keywords.forEach(keyword => {
      const enumValue = enumValues.find(value => value.label.toLowerCase() === keyword);
      if (enumValue) {
        translatedEnums.push(enumValue);
      }
    });

    translatedEnums.forEach(enumValue => {
      keywords.splice(keywords.indexOf(enumValue.label.toLowerCase()), 1);
    });

    if (translatedEnums.length > 0) {
      params.keyword = keywords.join(',');
      params[paramName] = Array.from(translatedEnums.map(enumValue => enumValue.value)).join(',');
    } else {
      params[paramName] = null;
    }

    return params;
  }

  translateBoolean(params: ListHttpParameters, paramName: string, trueLabel: string, falseLabel: string): ListHttpParameters {
    if (!params.keyword) {
      params[paramName] = null;
      return params;
    }

    const keywords = this.splitKeywords(params.keyword);
    const trueIndex = keywords.indexOf(trueLabel.toLowerCase());
    const falseIndex = keywords.indexOf(falseLabel.toLowerCase());

    if (trueIndex >= 0) {
      params[paramName] = true;
      keywords.splice(trueIndex, 1);
    } else if (falseIndex >= 0) {
      params[paramName] = false;
      keywords.splice(falseIndex, 1);
    } else {
      params[paramName] = null;
      return params;
    }

    params.keyword = keywords.join(',');
    return params;
  }

  translateString(params: ListHttpParameters, paramName: string, translationPrefix: string): ListHttpParameters {
    if (!params.keyword) {
      params[paramName] = null;
      return params;
    }

    const keywords = this.splitKeywords(params.keyword);
    let foundIndex = null;
    keywords.forEach((keyword, i) => {
      if (keyword.includes(':')) {
        const matchedKeyword = keyword.split(':');
        if (matchedKeyword.length === 2 && matchedKeyword[0].trim() === translationPrefix.toLowerCase().trim() && matchedKeyword[1]) {
          params[paramName] = matchedKeyword[1];
          foundIndex = i;
        }
      }
    });

    if (foundIndex !== null) {
      keywords.splice(foundIndex, 1);
    } else {
      params[paramName] = null;
    }

    params.keyword = keywords.join(',');
    return params;
  }

  private splitKeywords(keywords: string): string[] {
    // return keywords.toLowerCase().split(',').map(keyword => keyword.trim()).filter(keyword => !!keyword);
    return keywords.split(',').map(keyword => keyword.trim()).filter(keyword => !!keyword);
  }

  private getEnumLabelsValues(enums: any): EnumLabelValue [] {
    const translatedLabel: EnumLabelValue[] = [];
    if (enums.getClassName) {
      for (const key of Object.keys(enums).filter((type) => isNaN(type as any) &&
        !(enums.getClassName && type === enums.getClassName.name))) {
        translatedLabel.push({label: this.translateService.instant('enums.' + enums.getClassName() + '.' + key), value: enums[key]});
      }
    }
    return translatedLabel;
  }

}

export interface EnumLabelValue {
  label: string;
  value: string;
}
